import * as React from 'react';
import {SVGProps} from 'react';
const X = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="0.80em"
    stroke="currentColor"
    viewBox="0 0 20 20"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1688_6176)">
      <path
        d="M11.6408 8.46429L18.9224 0H17.1969L10.8743 7.34942L5.82442 0H0L7.63638 11.1136L0 19.9897H1.72561L8.40246 12.2285L13.7355 19.9897H19.5599L11.6404 8.46429H11.6408ZM9.27734 11.2115L8.50362 10.1049L2.34737 1.29901H4.9978L9.96597 8.40562L10.7397 9.51229L17.1977 18.7498H14.5473L9.27734 11.212V11.2115Z"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default X;
